<h2 mat-dialog-title class="gsd-title">Gestionar servicios del día</h2>

<div mat-dialog-content class="gsd-content">
  <p class="gsd-contexto">
    Bodega <strong>{{ data.codigoBodega }}</strong> · Día de picking <strong>{{ data.fechaPicking }}</strong>
  </p>

  <div class="gsd-resumen">
    <div class="gsd-stat gsd-stat--total">
      <span class="gsd-stat-valor">{{ data.totalServicios }}</span>
      <span class="gsd-stat-label">Total servicios</span>
    </div>
    <div class="gsd-stat gsd-stat--abiertos">
      <span class="gsd-stat-valor">{{ data.elegiblesCierre }}</span>
      <span class="gsd-stat-label">Abiertos</span>
    </div>
    <div class="gsd-stat gsd-stat--cerrados">
      <span class="gsd-stat-valor">{{ data.elegiblesApertura }}</span>
      <span class="gsd-stat-label">Cerrados</span>
    </div>
  </div>

  <p class="gsd-ayuda" *ngIf="data.totalServicios === 0">
    No hay servicios registrados para este día de picking.
  </p>
  <p class="gsd-ayuda" *ngIf="data.totalServicios > 0">
    Elige una acción para aplicarla a todos los servicios elegibles de una sola vez.
  </p>
</div>

<div mat-dialog-actions align="end" class="gsd-actions">
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button class="gsd-btn-cerrar" [disabled]="data.elegiblesCierre === 0" (click)="cerrarTodos()">
    <mat-icon class="gsd-btn-icon">lock</mat-icon>
    Cerrar los {{ data.elegiblesCierre }} abiertos
  </button>
  <button mat-raised-button class="gsd-btn-abrir" [disabled]="data.elegiblesApertura === 0" (click)="abrirTodos()">
    <mat-icon class="gsd-btn-icon">lock_open</mat-icon>
    Abrir los {{ data.elegiblesApertura }} cerrados
  </button>
</div>
